export async function UpdatePracticaProblemaDepende(idAct: string, idProb: string, depende: string | null) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}:8061/jutge/activitats/${idAct}/problemes/${idProb}/dependencia`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ depende: depende })
    });
    return response;
}
